export interface AnchorLink {
    path: string
    hash: string
}

export function getAnchorLink(link: string): AnchorLink {
    const [path, hash] = link.replaceAll('/', '').split('#')

    return {
        path: `/${path}/`,
        hash: hash ? '#' + hash : '',
    }
}
